import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ReferenceDataLabels } from '../../../../../lib/constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../../../../lib/constants/reference-data-option-lists';
import { Address } from '../../../../../lib/models/api/address.model';
import { MortgageApplicationService } from '../../../services/mortgage-application.service';
import { MortgageApplication } from './../../../models/mortgage-application.model';

@Component({
  selector: 'boi-form-address',
  templateUrl: './form-address.component.html',
  styleUrls: ['./form-address.component.scss']
})
export class FormAddressComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public propertyName: string;
  @Input() public labelName: string;
  @Input() public address: Address;

  @Input() public forcePostcodeNotRequired = false;
  @Input() public showSolicitorTooltip = false;
  @Input() public addressLine1Required: boolean;
  @Input() public contextualHelpName: string;
  @Input() public areFieldsDisabled: boolean;
  @Input() public showCountryCode: boolean;
  @Input() public hideFindAddress: boolean;
  @Input() public isFindAddressButtonDisabled: boolean;
  @Input() public mortgageApplication: MortgageApplication;

  @Output() public readonly addressChange: EventEmitter<Address> = new EventEmitter<Address>();

  referenceDataLabels = ReferenceDataLabels;
  referenceDataOptionLists = ReferenceDataOptionLists;

  public previousAddressOpened: boolean;
  public addressOpened: boolean;
  public isCountryTypeUk: boolean;
  public previousAddresses: Array<Address>;
  public addresses: Array<Address>;
  public selectedAddress: Address;
  private readonly destroySubject$ = new Subject();

  constructor(
    private readonly mortgageApplicationService: MortgageApplicationService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.checkCountryTypeIsUk();
  }

  ngOnChanges(): void {
    this.checkCountryTypeIsUk();
  }

  public checkCountryTypeIsUk(): void {
    this.address.CountryTypeCode = this.address.CountryTypeCode || this.referenceDataOptionLists.CountryTypeUk;
    this.isCountryTypeUk = this.address.CountryTypeCode === this.referenceDataOptionLists.CountryTypeUk;
    this.address.FromPaf = this.isCountryTypeUk;
  }

  public findPreviousAddresses(): void {
    if (this.areFieldsDisabled || this.mortgageApplication.IsApplicationReadOnly) {
      return;
    }
    this.previousAddressOpened = true;
    this.getPreviousAddresses();
  }

  public findAddresses(): void {
    this.getAddresses();
  }

  private getAddresses(): void {
    this.addresses = [];
    this.mortgageApplicationService
      .getAddresses(this.address.Postcode)
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(
        (data) => {
          this.addressOpened = true;
          this.addresses = data;
          this.cdr.detectChanges();
        },
        (error) => {}
      );
  }

  private getPreviousAddresses(): void {
    this.previousAddresses = [];
    this.mortgageApplicationService
      .getPreviousAddresses(this.mortgageApplication)
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((data) => {
        this.previousAddresses = data;
        this.cdr.detectChanges();
      });
  }

  private populateAddress(selectedAddress: Address): void {
    if (selectedAddress) {
      this.address.copyAddressFields(selectedAddress);
      this.addressChange.emit(this.address);
    }
  }

  public confirm(): void {
    if (this.selectedAddress) {
      this.populateAddress(this.selectedAddress);
      this.close();
    }
  }

  public close(): void {
    this.previousAddressOpened = false;
    this.addressOpened = false;
  }

  public ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }

  public setPostCodeUpperCase(): void {
    if (this.address.Postcode) {
      this.address.Postcode = this.address.Postcode.toUpperCase();
    }
  }
}
